import { ViewChild, ElementRef, Injectable } from '@angular/core';
import { AuthorizationService } from '../../services/authorization.service';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

@Injectable()
export class AuthGuard implements CanActivate {
  @ViewChild("ipusername") ipusername: ElementRef;
  constructor(private router: Router, public authorizationService: AuthorizationService) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> | boolean {
    console.log(route);
    var aa = localStorage.getItem('currentUser');
    //console.log('vao kiem tra quyen ');
    //console.log(aa);
    if (aa) {

      //return true;
      let data = JSON.parse(aa);
      if (data != null) {
        if (data.giang_vien == '0') {
          // Danh sách các đường dẫn được phép truy cập cho giang_vien == '0'
          const allowedPaths = [
            '/dashboard',
            '/dieuhanh/khoahoc',
            '/dieuhanh/solienlacview',
            '/dieuhanh/vaolop/'
          ];

          // Lấy path hiện tại từ URL
          const currentPath = state.url.split('?')[0]; // Loại bỏ query parameters

          // Kiểm tra nếu đường dẫn hiện tại bắt đầu với một trong các đường dẫn được phép
          const isAllowed = allowedPaths.some(path => currentPath.startsWith(path));

          if (!isAllowed) {
            // Nếu không được phép truy cập, chuyển hướng về dashboard
            this.router.navigate(['/dashboard'], { queryParams: { returnUrl: state.url } });
            return false;
          }

          // Nếu được phép truy cập, cho phép tiếp tục
          return true;
        }

      }
      return true;
      //console.log(route);
      //  if (route.data['auth'] == undefined)
      //      return this.hasRequiredPermission(route.firstChild.data['auth'], route.firstChild.data['func']);           
      //  var abc = this.hasRequiredPermission(route.data['auth'], route.data['func']);
      //  return abc;
    }

    //var ua = this.ipusername.nativeElement.value;
    //if (ua) {
    //  console.log('Vao Auth Router');
    //  console.log(ua);
    //  this.router.navigate(['/waitlogin'], { queryParams: { returnUrl: state.url } });
    //  return false;

    //}

    // not logged in so redirect to login page with the return url
    console.log('redirect to login');
    this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
    return false;
  }
  protected hasRequiredPermission(authGroup: number, functionid: string): Promise<boolean> | boolean {
    console.log('vao kiem tra quyen ' + authGroup)

    if (authGroup == 0)
      return true;

    // If user's permissions already retrieved from the API
    if (this.authorizationService.permissions && this.authorizationService.permissions.length > 0) {
      console.log('Da co quyen')
      //console.log(this.authorizationService.permissions);
      var abc = this.authorizationService.hasPermission(authGroup, functionid);
      console.log(abc);
      return abc;
    } else {
      console.log('vao khoi tao phan quyen')
      // Otherwise, must request permissions from the API first
      const promise = new Promise<boolean>((resolve, reject) => {
        this.authorizationService.initializePermissions()
          .then(() => {
            var ms = this.authorizationService.hasPermission(authGroup, functionid);
            console.log("test ms");
            console.log(ms);
            resolve(ms);

          }).catch(() => {
            resolve(false);
          });
      });

      return promise;
    }
  }
}
